import {
    allFetch,
    ResultObj
} from "../Domain";


/**
 *  @description 審核流程查詢(參數)
 *  @param type 種類(請假、銷假、加班、調班)之類的
 *  @param id 流水號
 *  @param status 審核流程狀態
 *  @param page 頁碼
 *  @param num_per_page 一頁幾筆
 * 
 */
export interface AuditProcedureSearchParams {
    type: string,
    id: string,
    status: string,
    page: number,
    num_per_page: number
}
/**
 *  @description 審核流程查詢(回傳)
 */
export interface AuditProcedureSearchResItem {
    audit_json: string;
    audit_procedure_id: number;
    cre_time: string;
    id: string;
    note: string;
    status: string;
    type: string;
}
/**
 *  @description 審核流程查詢
 */
export const AuditProcedureSearch =
    async (obj: AuditProcedureSearchParams = {
        type: '',
        id: '',
        status: '',
        page: 0,
        num_per_page: 10,
    }): Promise<ResultObj<AuditProcedureSearchResItem[]>> => await allFetch('Audit/AuditProcedureSearch', obj);


/**
*  @description 進審核頁面呼叫，決定審核按鈕要不要出現(參數)
*  @param id 流水號
*/
export interface AuditProcedureButtomCheckParams {
    id: string,

}

/**
*  @description 進審核頁面呼叫，決定審核按鈕要不要出現(回傳)
*/
export interface AuditProcedureButtomCheckResItem {
    save_btn: boolean,
     audit_btn: boolean
}
/**
*  @description 進審核頁面呼叫，決定審核按鈕要不要出現
*/
export const AuditProcedureButtomCheck =
    async (obj: AuditProcedureButtomCheckParams = {
        id: ''
    }): Promise<ResultObj<AuditProcedureButtomCheckResItem>> => await allFetch('Audit/AuditProcedureButtomCheck', obj);

    